<template>
    <div class="breadcrumbs">
        <NuxtLinkLocale to="/">Home</NuxtLinkLocale>
        <template v-for="route in routes.current">
            <NuxtLinkLocale v-if="route.slug" :to="route.slug"><span>{{ route.label }}</span></NuxtLinkLocale>
            <span class="lastLink" v-else>{{ route.label }}</span>
        </template>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ routes: { slug_it: string, slug_en: string, slug_fr: string, current: { slug?: string, label: string }[] } }>()
</script>

<style lang="scss" scoped>
.breadcrumbs {
    position: relative;
    font-size: var(--font-size-footer);
    line-height: var(--font-line-footer);

    display: flex;
    flex-direction: row;
    align-items: baseline;
    flex-wrap: wrap;

    a {
        display: inline-flex;
        color: var(--color-azure-dark);
        font-weight: 600;
        text-decoration: none;
        white-space: nowrap;



        span {
            display: inline-block;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &:after {
            content: "\203A";
            font-weight: normal;
            margin: 0 5px;
            opacity: 0.5;
        }
    }

    .lastLink {
        display: inline-block;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

@media screen and (max-width: 1279px) {
    .breadcrumbs {
        a {
            display: none;

            span {
                max-width: calc(100vw - var(--margin-page) * 2 - 24px);
            }

            &:after {
                content: none
            }

            &:last-of-type {
                display: inline-block;
            }
        }

        .lastLink {
            display: none;
        }
    }
}
</style>